import { createAction } from '@reduxjs/toolkit';

const gotoClientPortal = createAction<{ embeddedSessionToken: string } | undefined>('route/gotoClientPortal');
const gotoVerifyApp = createAction('route/gotoVerifyApp');
const gotoCreditApp = createAction('route/gotoCreditApp');

export { gotoClientPortal, gotoVerifyApp, gotoCreditApp };
